import $ from "jquery";
// import "jquery-ui/ui/core";
// import "jquery-ui/ui/widget";
// import "jquery-ui/ui/effect";
// import "jquery-ui/ui/jquery-1-7";
import "jquery-ui/ui/widgets/accordion";
import "jquery-ui/ui/widgets/tabs";
import "slick-carousel";

/* eslint-disable */
export default function generic() {
  $.fn.extend({
    toggleText: function (a, b) {
      return this.text(this.text() == b ? a : b);
    },
  });

  var allPanels = $("#accordion .content").hide();

  $("#accordion h3").click(function () {
    if ($(this).hasClass("active")) {
      $("#accordion h3.active").removeClass("active");
      $(this).next().slideUp();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    } else {
      allPanels.slideUp();
      $("#accordion h3.active").removeClass("active");
      $("#accordion h3").children(".expand").text("+");
      $(this).addClass("active");
      $(this).next().slideDown();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    }
  });


  //
  var overviewAllPanels = $("#overview-accordion .content").hide();

  $("#overview-accordion h3").click(function () {
    if ($(this).hasClass("active")) {
      $("#overview-accordion h3.active").removeClass("active");
      $(this).next().slideUp();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    } else {
      overviewAllPanels.slideUp();
      $("#overview-accordion h3.active").removeClass("active");
      $("#overview-accordion h3").children(".expand").text("+");
      $(this).addClass("active");
      $(this).next().slideDown();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    }
  });
  //

  //Resort
  var resortAllPanels = $("#resort-accordion .content").hide();
  $("#resort-accordion h3").click(function () {
    if ($(this).hasClass("active")) {
      $("#resort-accordion h3.active").removeClass("active");
      $(this).next().slideUp();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    } else {
      resortAllPanels.slideUp();
      $("#resort-accordion h3.active").removeClass("active");
      $("#resort-accordion h3").children(".expand").text("+");
      $(this).addClass("active");
      $(this).next().slideDown();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    }
  });
  //End Resort

  //Coaching
  var coachingAllPanels = $("#coaching-accordion .content").hide();
  $("#coaching-accordion h3").click(function () {
    if ($(this).hasClass("active")) {
      $("#coaching-accordion h3.active").removeClass("active");
      $(this).next().slideUp();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    } else {
      coachingAllPanels.slideUp();
      $("#coaching-accordion h3.active").removeClass("active");
      $("#coaching-accordion h3").children(".expand").text("+");
      $(this).addClass("active");
      $(this).next().slideDown();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    }
  });
  //End Coaching

  //Coaching Meet Coaches
  var c_meet_coachesAllPanels = $("#c_meet_coaches-accordion .content").hide();
  $("#c_meet_coaches-accordion h3").click(function () {
    if ($(this).hasClass("active")) {
      $("#c_meet_coaches-accordion h3.active").removeClass("active");
      $(this).next().slideUp();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    } else {
      c_meet_coachesAllPanels.slideUp();
      $("#c_meet_coaches-accordion h3.active").removeClass("active");
      $("#c_meet_coaches-accordion h3").children(".expand").text("+");
      $(this).addClass("active");
      $(this).next().slideDown();
      $(this).children(".expand").toggleText("-", "+");
      return false;
    }
  });
  //End Coaching Meet Coaches


  $(".nss-tabs").tabs({ hide: "fade", show: "fade" });

  $("#ability-tabs").tabs({ hide: "fade", show: "fade" });
  $("#equipment-tabs").tabs({ hide: "fade", show: "fade" });
  $("#accommodation-food-tabs").tabs({ hide: "fade", show: "fade" });
  $(".js-equipment-tabs").tabs({ hide: "fade", show: "fade" });

  $("#dates-prices-tabs").tabs({ hide: "fade", show: "fade" });

  // Course Dates & Prices toggleAccordion
  $(".toggle_btn").click(function (e) {
    toggleAccordion(this);
  });
  function toggleAccordion(element) {
    element = element.closest('.bg-lightestgrey');
    const content = element.nextElementSibling;
    content.classList.toggle('hidden');
    const icon = element.querySelector('span.toggle_btn');
    icon.textContent = content.classList.contains('hidden') ? 'Full Detail +' : 'Less Detail -';
  }

  $(".switcher a").click(function () {
    var $type = $(this).attr("data-type");
    $(".courses-wrapper.active, .switcher a").removeClass("active");
    $(".courses-wrapper." + $type + "-courses-container").addClass("active");
    var $numItems = $(".courses-wrapper.active .single-course-item").length;
    if ($numItems == 1) {
      $("#course-plural").hide();
    } else {
      $("#course-plural").show();
    }
    $("#course-count").text($numItems);
    $(this).addClass("active");
  });
  $(".filter-trigger").click(function () {
    $(".filters-popout").slideToggle();
    $(".filter-trigger span").toggleText("-", "+");
  });
  $(".testimonials-filter-trigger").click(function () {
    $(".testimonials-filters-popout").slideToggle();
    $(".testimonials-filter-trigger span").toggleText("-", "+");
  });
  $("#filters-reset").click(function () {
    $(".filters-popout input:checkbox").removeAttr("checked");
    $.fn.filter();
  });
  $("#testimonials-filters-reset").click(function () {
    $(".testimonials-filters-popout input:checkbox").removeAttr("checked");
    $.fn.testimonialsfilter();
  });

  var lastScrollTop = 0;

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    var stickySibling = $(".sticky");
    // $(".tab-panels .panel").removeClass("active-tab");
    $(".section-tabs .scroll-section").each(function () {
      var sectionTop = $(this).offset().top;
      var triggerTop = scrollTop + window.innerHeight * 0.05;
      var triggerBottom = scrollTop + window.innerHeight * 0.25;
      var $parent = $(this).parent();
      var $section_id = $parent.attr("id");
      var $nextSection_id = $parent.next().attr("id");

      if (scrollTop > lastScrollTop) {
        if (sectionTop < triggerTop) {
          stickySibling
            .find('a[href*="#' + $section_id + '"]')
            .removeClass("current");
          stickySibling
            .find('a[href*="#' + $nextSection_id + '"]')
            .addClass("current");
          $(this).addClass("md:opacity-25");
          $parent
            .next()
            .find(".scroll-section")
            .removeClass("md:opacity-25")
            .addClass("md:opacity-full");
        }
      } else {
        if (sectionTop + $(this).height() > triggerBottom) {
          stickySibling.find("a").removeClass("current");
          stickySibling
            .find('a[href*="#' + $section_id + '"]')
            .addClass("current");
          $(this).removeClass("md:opacity-25").addClass("md:opacity-full");
          $parent
            .next()
            .find(".scroll-section")
            .removeClass("md:opacity-full")
            .addClass("md:opacity-25");
          return false;
        }
      }
    });
    lastScrollTop = scrollTop;
  });

  // $(".section-tabs a").on("click", function () {
  //   // console.log($(this).attr("href"));
  //   const target = $(this).attr("href");
  //   console.log(target);
  //   $(target).addClass("active-tab");
  // });

  $(document).on("click", ".form-modal .request-type a", function () {
    var $type = $(this).attr("data-type");
    if ($type == 1) {
      $(".form-modal .page").removeClass("active");
      $(".form-modal #page-1").addClass("active");
      $(".form-modal .request-type a").removeClass("active");
      $(this).addClass("active");
      $(".form-modal .navigation").slideDown();
      $(".form-modal .email-submit").hide();
      $(".form-modal .email-acceptance").hide();
    } else {
      $(".form-modal .request-type a").removeClass("active");
      $(this).addClass("active");
      $(".form-modal .dot").removeClass("active");
      $(".form-modal #dot-1").addClass("active");
      $(".form-modal .trigger").removeClass("active");
      $(".form-modal #trigger-1").addClass("active");
      $(".form-modal .page").removeClass("active");
      $(".form-modal #page-1").addClass("active");
      $(".form-modal .navigation").slideUp();
      $(".form-modal .email-submit").fadeIn();
      $(".form-modal .email-acceptance").fadeIn();
    }
  });

  $(document).on(
    "click",
    ".form-modal .trigger, .form-modal .dot",
    function () {
      var $trigger = $(this).attr("data-type");
      $(".form-modal .page").removeClass("active");
      $(".form-modal #page-" + $trigger).addClass("active");
      $(".form-modal .dot").removeClass("active");
      $(".form-modal #dot-" + $trigger).addClass("active");
      $(".form-modal .trigger").removeClass("active");
      $(".form-modal #trigger-" + $trigger).addClass("active");
    }
  );

  $(".form-modal .close").click(function () {
    //$('.form-overlay').css('opacity', 0);
    $(".form-overlay").fadeOut();
  });

  $(".brochure-trigger a").click(function (event) {
    event.preventDefault;

    if ($(".js-mobile-nav").hasClass("is-open")) {
      var url = window.location.href;
      var baseUrl = url.split("/")[0] + "//" + url.split("/")[2];
      var brochureUrl = baseUrl + "/brochure";
      window.location.href = brochureUrl;
    }
    $(".form-overlay:not(.form-overlay--guide)").fadeIn();
    //$('.form-overlay').delay(500).css('opacity', 100);
  });

  $(".brochure-form .request-type a").click(function () {
    var $type = $(this).attr("data-type");
    if ($type == 1) {
      $(".brochure-form #page-2").slideDown();
      $(".brochure-form .email-submit").hide();
      $(".brochure-form .email-acceptance").hide();
    } else {
      $(".brochure-form #page-2").hide();
      $(".brochure-form .email-submit").fadeIn();
      $(".brochure-form .email-acceptance").fadeIn();
    }
    $(".brochure-form .request-type a").removeClass("active");
    $(this).addClass("active");
  });

  $(".contact-form .trigger").click(function () {
    var $trigger = $(this).attr("data-type");
    $(".contact-form .page").removeClass("active");
    $(".contact-form #page-" + $trigger).addClass("active");
    $(".contact-form .trigger").toggleClass("active");
    $(".contact-form .submit-wrapper").toggleClass("active");
  });

  $(".address-box .trigger").click(function () {
    var $trigger = $(this).attr("data-type");
    if ($(".address-box #address-" + $trigger).hasClass("active")) {
      $(".address-box .address-details").removeClass("active");
      $(".address-box .address-details").slideUp();
    } else {
      $(".address-box .trigger").removeClass("active");
      $(".address-box #trigger-" + $trigger).addClass("active");
      $(".address-box .address-details").slideUp();
      $(".address-box .address-details").removeClass("active");
      $(".address-box #address-" + $trigger).addClass("active");
      $(".address-box #address-" + $trigger).slideDown();
    }
  });

  $(".address-box .address-details").slideDown({
    start: function () {
      $(this).css({
        display: "flex",
      });
    },
  });

  $(".address-box .address-details").slideUp();

  var timeAccommodation = 2;
  var $barAccommodation,
    isPauseAccommodation,
    tickAccommodation,
    percentTimeAccommodation,
    $accomodation;

  $accomodation = $(".accomodation-slider");

  $(".accomodation-tabs, #accommodation-food-tabs").tabs({
    hide: "fade",
    show: "fade",
    activate: function (event, ui) {
      $accomodation.slick("unslick");
      $accomodation.slick();
      startProgressbarAccommodation();
    },
  });

  $barAccommodation = $("#accommodation .slider-progress .progress");

  function startProgressbarAccommodation() {
    resetProgressbarAccommodation();
    percentTimeAccommodation = 0;
    isPauseAccommodation = false;
    tickAccommodation = setInterval(intervalAccommodation, 30);
  }

  function intervalAccommodation() {
    if (isPauseAccommodation === false) {
      percentTimeAccommodation += 1 / (timeAccommodation + 0.1);
      $barAccommodation.css({
        width: percentTimeAccommodation + "%",
      });
      if (percentTimeAccommodation >= 100) {
        $accomodation.slick("slickNext");
        startProgressbarAccommodation();
      }
    }
  }

  function resetProgressbarAccommodation() {
    $barAccommodation.css({
      width: 0 + "%",
    });
    clearTimeout(tickAccommodation);
  }

  startProgressbarAccommodation();

  $(
    "#accommodation .accomodation-next, #accomodation .accomodation-prev"
  ).click(function () {
    startProgressbarAccommodation();
  });

  $("#accommodation .accomodation-prev").click(function () {
    $("#accommodation .accomodation-slider").slick("slickPrev");
  });
  $("#accommodation .accomodation-next").click(function () {
    $("#accommodation .accomodation-slider").slick("slickNext");
  });

  function toggleInclusion(element) {
    element.toggleClass("text-red");
    element.find(".include-arrow").toggleClass("active");
    element.parent().find(".include-text").toggle();
  }

  $("#inclusion-tabs .include-trigger, #inclusions .include-trigger").click(
    function () {
      toggleInclusion($(this));
    }
  );

  var courseGuide = document.querySelector("#js-course-guide-form");
  if (courseGuide) {
    courseGuide.addEventListener(
      "wpcf7mailsent",
      function (event) {
        var $download = $(this)
          .parents(".js-course-guide-container")
          .attr("data-course-guide");
        window.open($download, "_blank");
      },
      false
    );
  }

  // $(".js-course-trigger").click(function (event) {
  //   event.preventDefault;
  //   $(".form-overlay--guide").fadeIn();
  // });

  $(".js-course-trigger").mouseup(function () {
    var wasDragging = false;
    if (!wasDragging) {
      $(".popout-box-form").fadeIn();
      $(".popout-overlay").css("opacity", 100);
      $(".popout-overlay .loading").fadeIn();

      $(".popout-overlay .loading").fadeOut();
      $(".popout-inner").css("right", 0);

      var popoutBoxFormHeight = $(".popout-box-form-height").innerHeight();
      console.log("popout-box-form-height", popoutBoxFormHeight);
      $(".popout-box-form-img").css('height', popoutBoxFormHeight);
    }
  });

  $(".js-enquiry_form-trigger").mouseup(function () {
    var wasDragging = false;
    if (!wasDragging) {
      $(".popout-enquiry-form").fadeIn();
      $(".popout-overlay").css("opacity", 100);
      $(".popout-overlay .loading").fadeIn();

      $(".popout-overlay .loading").fadeOut();
      $(".popout-inner").css("right", 0);
    }
  });


}

var prevScrollpos = window.pageYOffset;
var $desktopHeader = $("header.desktop-header");
var desktopHeaderHeight = $($desktopHeader).height();
var $mega_menu = $(".mega-menu");

function handleScroll() {
  var currentScrollPos = window.pageYOffset;
  var megaMenuHeight = desktopHeaderHeight + currentScrollPos;

  if (prevScrollpos > currentScrollPos) {
    if (currentScrollPos <= 5) {
      // Added a tolerance of 5 pixels
      $($desktopHeader).removeClass("visible fixed sticky-header mt-0");
      if ($($desktopHeader).hasClass("has-promo")) {
        $($desktopHeader).addClass("mt-10");
      }
      $($mega_menu).attr("style", "");
    } else {
      $($desktopHeader).addClass(
        "fixed sticky-header mt-0 header-transition visible"
      );
      $($desktopHeader).removeClass("mt-10");
      $($mega_menu).css("top", megaMenuHeight);
    }
  } else {
    $($desktopHeader).removeClass("visible");
    $($mega_menu).attr("style", "");
  }
  prevScrollpos = currentScrollPos;
}

window.onscroll = function () {
  window.requestAnimationFrame(handleScroll);
};

$(window).on("scroll", function () {
  var scrollPos = $(this).scrollTop();
  $(".parallax-container").css({
    "background-position-y": scrollPos / 2 + "px",
  });
});

$(".js-tabs-link").on("click", function (e) {
  var tab_number = $(this).attr("data-tab");
  $(".js-tabs-tab").addClass("hidden");
  $('.js-tabs-tab[data-tab="' + tab_number + '"]').removeClass("hidden");
  $(".js-tabs-link").removeClass("text-red");
  $(".js-tabs-link").addClass("text-lightgrey");
  $('.js-tabs-link[data-tab="' + tab_number + '"]').addClass("text-red");
  $('.js-tabs-link[data-tab="' + tab_number + '"]').removeClass(
    "text-lightgrey"
  );
});

$(".js-course-1-trigger").on("click", function (e) {
  $(this).addClass("text-red");
  $(".js-course-2-trigger").removeClass("text-red");
  $(".js-course-1").removeClass("hidden");
  $(".js-course-1").addClass("block");
  $(".js-course-2").addClass("hidden");
});

$(".js-course-2-trigger").on("click", function (e) {
  $(this).addClass("text-red");
  $(".js-course-1-trigger").removeClass("text-red");
  $(".js-course-2").removeClass("hidden");
  $(".js-course-2").addClass("block");
  $(".js-course-1").addClass("hidden");
});

$(".contact-form-block .wpcf7-submit").wrap(
  '<span class="submit-wrapper"></span>'
);

/* What's included header to be aware of navigation menu */
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".desktop-header");
  const inclusionHeader = $(".inclusion-header");

  if (inclusionHeader.length) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          var computedStyle = window.getComputedStyle(header);
          if (
            header.classList.contains("visible") &&
            computedStyle.display !== "none"
          ) {
            inclusionHeader.css({
              top: "75px",
            });
          } else {
            inclusionHeader.css({
              top: "0",
            });
          }
        }
      });
    });
    // Configuration of the observer:
    var config = { attributes: true };
    observer.observe(header, config);
  }
});
